import * as React from 'react';
type Props = {
  className?: string;
};
export function ArrowRightNew({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-arrow-right-new"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4178 4.40588L16.5012 9.4052C16.6604 9.56185 16.7501 9.77589 16.7502 9.99929C16.7502 10.2227 16.6605 10.4367 16.5012 10.5934L11.4179 15.5941L10.2491 14.406L13.8742 10.8398H3.3335V9.1731H13.8882L10.2492 5.59417L11.4178 4.40588Z"
        fill="currentColor"
      />
    </svg>
  );
}
